import React, { useEffect } from 'react'
import img1 from '../../img/WhatsApp Image 2024-09-20 at 21.17.41_efa957f4.jpg'

import about1 from '../../img/50-easy-ways-to-eat-more-fruit-and-veg-iStock-1225383160-removebg-preview.png'
import about2 from '../../img/product-1.png'
import prod33 from '../../img/prods/vvv.png';
import prod1 from '../../img/prods/orane-removebg-preview.png';
import prod2 from '../../img/prods/download.png';
import prod3 from '../../img/prods/images- Fresh mandarin.png';
import prod4 from '../../img/prods/png-transparent-bunch-of-white-grapes-muscat-wine-juice-concord-grape-grape-natural-foods-food-wine-thumbnail.png';
import prod5 from '../../img/prods/png-transparent-strawberry-fruit-strawberry-strawberry-clipart-thumbnail.png';
import prod6 from '../../img/prods/png-transparent-pomegranate-juice-fruit-food-pomegranate-natural-foods-frutti-di-bosco-dried-fruit-thumbnail.png';
import prod7 from '../../img/prods/Bunch-Carrots.png';
import prod8 from '../../img/prods/red-removebg-preview.png';
import prod9 from '../../img/prods/png-transparent-chili-red-chili-vegetables-thumbnail.png';
import prod10 from '../../img/prods/png-transparent-garlic-white-garlic-vegetables-thumbnail.png';
import prod11 from '../../img/prods/vegetable-item-5-removebg-preview.png';
import prod12 from '../../img/prods/png-clipart-red-sweet-potatoes-sweet-potato-root-vegetables-tuber-sweet-potato-food-potatoes-thumbnail.png';
import prod13 from '../../img/prods/barhi_1_0.png';
import prod14 from '../../img/prods/green-cap-removebg-preview.png';
import prod15 from '../../img/prods/B62-300x300.png';

import pack1 from '../../img/frozen/orka.png';
import pack2 from '../../img/frozen/bottoms.png';
import pack3 from '../../img/frozen/broccli-removebg-preview.png';
import pack4 from '../../img/frozen/fries-removebg-preview.png';
import pack5 from '../../img/frozen/gaulif-removebg-preview.png';
import pack6 from '../../img/frozen/peas-removebg-preview.png';
import pack7 from '../../img/frozen/molokhia-removebg-preview.png';
import pack8 from '../../img/frozen/strawberries.png-removebg-preview.png';
import pack9 from '../../img/frozen/guava-removebg-preview.png';
import pack10 from '../../img/frozen/mango-removebg-preview.png';

import { Link } from 'react-router-dom'
import Aos from 'aos'
import 'aos/dist/aos.css'


export default function Home() {


    useEffect(() => {
        Aos.init({
            duration: 1000
        })

    }, [])


    return <>
        {/* Carousel Start */}
        <div className="container-fluid p-0">
            <div id="header-carousel" className="carousel slide carousel-fade" data-bs-ride="carousel">
                <div className="carousel-inner">
                    <div className="carousel-item active ">
                        <img className="w-100" src={img1} alt="mage" />
                        <div className="carousel-caption top-0 bottom-0 start-0 end-0 d-flex flex-column justify-content-center">
                            <div className="text-start p-5" style={{ maxWidth: "900px" }}>
                                <h3 className="text-white" data-aos="fade-left" data-aos-delay="100">Elshebany Farms</h3>
                                <h1 className="text-white mb-md-4 display-3" data-aos="fade-right" data-aos-delay="100">Fresh and frozen fruits  </h1>
                                <Link to='' className="btn btn-primary py-md-3 px-md-5 me-3 " data-aos="fade-down" data-aos-delay="100">Explore</Link>
                                <Link to='/contact' className="btn btn-secondary py-md-3 px-md-5" data-aos="fade-up" data-aos-delay="100">Contact</Link>
                            </div>
                        </div>
                    </div>
                    <div className="carousel-item">
                        <img className="w-100" src={img1} alt="mage" />
                        <div className="carousel-caption top-0 bottom-0 start-0 end-0 d-flex flex-column  justify-content-center">
                            <div className="text-start p-5" style={{ maxWidth: "900px" }}>
                                <h3 className="text-white" data-aos="fade-left" data-aos-delay="100">Elshebany Farms</h3>
                                <h1 className=" text-white mb-md-4 display-3" data-aos="fade-right" data-aos-delay="100">fresh and frozen vegetables </h1>
                                <Link to='' className="btn btn-primary py-md-3 px-md-5 me-3" data-aos="fade-down" data-aos-delay="100">Explore</Link>
                                <Link to='/contact' className="btn btn-secondary py-md-3 px-md-5" data-aos="fade-up" data-aos-delay="100">Contact</Link>
                            </div>
                        </div>
                    </div>
                </div>
                <button className="carousel-control-prev" type="button" data-bs-target="#header-carousel" data-bs-slide="prev">
                    <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Previous</span>
                </button>
                <button className="carousel-control-next" type="button" data-bs-target="#header-carousel" data-bs-slide="next">
                    <span className="carousel-control-next-icon" aria-hidden="true"></span>
                    <span className="visually-hidden">Next</span>
                </button>
            </div>
        </div>
        {/* Carousel End */}

        {/* Banner Start */}
        <div className="container-fluid banner mb-5">
            <div className="container">
                <div className="row gx-0 ">
                    <div className="col-md-8 mx-auto ">
                        <div className="bg-primary bg-vegetable d-flex flex-column justify-content-center p-5 " data-aos="fade-up" data-aos-delay="100" style={{ height: "300px" }}>
                            <h3 className="text-white mb-3" data-aos="fade-up" data-aos-delay="200">Elshebany Farms </h3>
                            
                        </div>
                    </div>

                </div>
            </div>
        </div>
        {/* Banner End */}

        {/* About Start */}
        <div className="container-fluid about pt-5">
            <div className="container">
                <div className="row gx-5">
                    <div className="col-lg-6 mb-5 mb-lg-0">
                        <div className="d-flex h-100 border border-5 border-primary border-bottom-0 pt-4">
                            <img className="img-fluid mt-auto mx-auto" src={about1} alt="About" />
                        </div>
                    </div>
                    <div className="col-lg-6 pb-5">
                        <div className="mb-3 pb-2">
                            <h6 className="text-primary text-uppercase">About Us</h6>
                            <h3>We are a prominent company specializing in the export of high-quality Egyptian
                                agricultural products, including fresh and frozen fruits and vegetables</h3>
                        </div>
                        <div className="row gx-5 gy-4">
                            <div className="col-sm-6" data-aos="fade-right" data-aos-delay="100">
                                <i className="fa fa-seedling display-5 text-secondary"></i>
                                <h4>Fresh fruits </h4>
                            </div>

                            <div className="col-sm-6" data-aos="fade-left" data-aos-delay="150">
                                <i className="fa fa-seedling display-5 text-secondary"></i>
                                <h4>Frozen fruits </h4>
                            </div>
                            <div className="col-sm-6" data-aos="fade-right" data-aos-delay="200">
                                <i className="fa fa-seedling display-5 text-secondary"></i>
                                <h4>Fresh vegetables </h4>
                            </div>
                            <div className="col-sm-6" data-aos="fade-left" data-aos-delay="250">
                                <i className="fa fa-seedling display-5 text-secondary"></i>
                                <h4>frozen vegetables</h4>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
        {/* About End */}

        {/* Features Start */}
        <div className="container-fluid bg-primary feature py-5 pb-lg-0 my-5">
            <div className="container py-5 pb-lg-0">
                <div className="mx-auto text-center mb-3 pb-2" style={{ maxWidth: "500px" }}>
                    <h6 className="text-uppercase text-secondary" data-aos="fade-up" data-aos-delay="100">Features</h6>
                    <h1 className="display-5 text-white" data-aos="fade-up" data-aos-delay="100">Why Choose Us</h1>
                </div>
                <div className="row g-5">
                    <div className="col-lg-3">
                        <div className="text-white mb-5" data-aos="fade-right" data-aos-delay="200">
                            <div className="bg-secondary rounded-pill d-flex align-items-center justify-content-center mb-3" style={{ width: "60px", height: "60px" }}>
                                <i className="fa fa-award fs-4 text-white"></i>
                            </div>
                            <h4 className="text-white">We can provide our customers with the best quality and best prices</h4>
                        </div>
                        <div className="text-white" data-aos="fade-right" data-aos-delay="200">
                            <div className="bg-secondary rounded-pill d-flex align-items-center justify-content-center mb-3" style={{ width: "60px", height: "60px" }}>
                                <i className="fa fa-award fs-4 text-white"></i>
                            </div>
                            <h4 className="text-white">We strive to satisfy our customers.</h4>
                        </div>
                    </div>
                    <div className="col-lg-6  ">
                        <div className="d-block bg-white h-100 text-center p-5 pb-lg-0 brdr  " data-aos="fade-up" data-aos-delay="100">
                            <h4>Our production comes from our own farms.</h4>
                            <img className="img-fluid" src={about2} alt="Feature" />
                        </div>
                    </div>
                    <div className="col-lg-3">
                        <div className="text-white mb-5" data-aos="fade-left" data-aos-delay="200">
                            <div className="bg-secondary rounded-pill d-flex align-items-center justify-content-center mb-3" style={{ width: "60px", height: "60px" }}>
                                <i className="fa fa-award fs-4 text-white"></i>
                            </div>
                            <h4 className="text-white">Our customer support team will provide our customers with all the assistance
                                required.</h4>
                        </div>
                        <div className="text-white" data-aos="fade-left" data-aos-delay="200">
                            <div className="bg-secondary rounded-pill d-flex align-items-center justify-content-center mb-3" style={{ width: "60px", height: "60px" }}>
                                <i className="fa fa-award fs-4 text-white"></i>
                            </div>
                            <h4 className="text-white">We have a variety of products.</h4>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        {/* Features End */}
        <div className="container-fluid py-5">
            <div className="container">
                <div className="bg-light p-5 rounded">
                    <div className="row g-4 justify-content-center">
                        <div className="col-md-6 col-lg-6 col-xl-3">
                            <div className="counter bg-white rounded p-5">
                                <i className="fa fa-users text-secondary"></i>
                                <h4>satisfied customers</h4>
                                <h1>1963</h1>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-6 col-xl-3">
                            <div className="counter bg-white rounded p-5">
                                <i className="fa fa-users text-secondary"></i>
                                <h4>quality of service</h4>
                                <h1>99%</h1>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-6 col-xl-3">
                            <div className="counter bg-white rounded p-5">
                                <i className="fa fa-users text-secondary"></i>
                                <h4>quality certificates</h4>
                                <h1>33</h1>
                            </div>
                        </div>
                        <div className="col-md-6 col-lg-6 col-xl-3">
                            <div className="counter bg-white rounded p-5">
                                <i className="fa fa-users text-secondary"></i>
                                <h4>Available Products</h4>
                                <h1>30</h1>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        {/* Services Start */}
        <div className="container-fluid py-5">
            <div className="container">
                <div className="row g-5">
                    <div className="col-lg-4 col-md-6">
                        <div className="mt-5" data-aos="fade-right" data-aos-delay="200">
                            <h6 className="text-primary text-uppercase">Our Story</h6>
                            <h1 className="display-5">Elshebany Farms Story</h1>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6" data-aos="fade-up" data-aos-delay="150">
                        <div className="service-item bg-light text-center p-5">
                            <i className="fa fa-seedling display-1 text-primary mb-3"></i>

                            <h4>journey</h4>
                            <p className="mb-0">Our journey began as farmers with years of experience, cultivating our own
                                vegetable and fruit farms. Over time, we have continuously enhanced our production
                                using the latest modern techniques, all while avoiding the use of pesticides, making
                                our produce ideal for export to Europe, the US, and beyond.
                            </p>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6"data-aos="fade-up" data-aos-delay="150">
                        <div className="service-item bg-light text-center p-5">
                            <i className="fa fa-seedling display-1 text-primary mb-3"></i>

                            <h4>currently</h4>
                            <p className="mb-0">We are currently considering establishing our own packing facility in the near future,
                                along with a factory for concentrated juices. The exceptional quality of our farm
                                products has attracted exporting companies, which purchase and distribute our crops
                                globally</p>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6"data-aos="fade-up" data-aos-delay="150">
                        <div className="service-item bg-light text-center p-5">
                            <i className="fa fa-seedling display-1 text-primary mb-3"></i>

                            <h4>inspiration</h4>
                            <p className="mb-0">This inspired us to launch ElShaibany Company, dedicated to exporting our highquality farm produce worldwide. We have partnered with state-of-the-art sorting and
                                packing stations that are fully certified and equipped with a skilled workforce</p>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6"data-aos="fade-up" data-aos-delay="150">
                        <div className="service-item bg-light text-center p-5">
                            <i className="fa fa-seedling display-1 text-primary mb-3"></i>

                            <h4>vision</h4>
                            <p className="mb-0">Our vision is to expand into key global markets, opening offices in countries that
                                import from Egypt. This demonstrates our commitment to global growth by
                                regularly participating in international exhibitions. Additionally, we are exploring
                                partnerships with European and international importers of fruits and vegetables.</p>
                        </div>
                    </div>
                    <div className="col-lg-4 col-md-6"data-aos="fade-up" data-aos-delay="150">
                        <div className="service-item bg-light text-center p-5">
                            <i className="fa fa-seedling display-1 text-primary mb-3"></i>
                            <h4>mission</h4>
                            <p className="mb-0">Our mission is to deliver premium products, build long-term partnerships, and
                                become a trusted supplier for our clients. We welcome our customers to visit our
                                farms at any time to explore potential collaborations.</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        {/* Services End */}


        {/* fresh Products Start */}
        <div className="container-fluid py-5">
            <div className="container">
                <div className="mx-auto text-center mb-5" style={{ maxWidth: '500px' }}>
                    <h6 className="text-primary text-uppercase">Products</h6>
                    <h1 className="display-5">Our Fresh Products</h1>
                </div>
                <div className="row text-center">
                    {/* Product 1 */}
                    <div className="col-md-3 mb-4"data-aos="fade-up" data-aos-delay="200">
                        <div className="product-item  bg-white ">
                            <img className="img-fluid mb-4" style={{ width: '206px', height: '206px' }} src={prod33} alt="Organic Vegetable" />
                            <h6 className="mb-3">Valencia Orange</h6>
                            <Link to='/valincia' className='btn btd-primary bg-primary text-light '>details</Link>

                        </div>
                    </div>

                    {/* Product 2 */}
                    <div className="col-md-3 mb-4"data-aos="fade-up" data-aos-delay="200">
                        <div className="product-item  bg-white ">
                            <img className="img-fluid mb-4" style={{ width: '206px', height: '206px' }} src={prod1} alt="Organic Vegetable" />
                            <h6 className="mb-3">Navel oranges   </h6>
                            <Link to='/navel' className='btn btd-primary bg-primary text-light '>details</Link>

                        </div>
                    </div>

                    {/* Product 3 */}
                    <div className="col-md-3 mb-4"data-aos="fade-up" data-aos-delay="200">
                        <div className="product-item bg-white ">
                            <img className="img-fluid mb-4" style={{ width: '206px', height: '206px' }} src={prod2} alt="Organic Vegetable" />
                            <h6 className="mb-3">Lemons </h6>
                            <Link to='/lemon' className='btn btd-primary bg-primary text-light '>details</Link>

                        </div>
                    </div>

                    <div className="col-md-3 mb-4"data-aos="fade-up" data-aos-delay="200">
                        <div className="product-item bg-white ">
                            <img className="img-fluid mb-4" style={{ width: '206px', height: '206px' }} src={prod3} alt="Organic Vegetable" />
                            <h6 className="mb-3"> Fresh mandarin </h6>
                            <Link to='/mandarin' className='btn btd-primary bg-primary text-light '>details</Link>

                        </div>
                    </div>


                    <div className="col-md-3 mb-4"data-aos="fade-up" data-aos-delay="200">
                        <div className="product-item bg-white ">
                            <img className="img-fluid mb-4" style={{ width: '206px', height: '206px' }} src={prod4} alt="Organic Vegetable" />
                            <h6 className="mb-3"> Grapes </h6>
                            <Link to='/grapes' className='btn btd-primary bg-primary text-light '>details</Link>

                        </div>
                    </div>


                    <div className="col-md-3 mb-4"data-aos="fade-up" data-aos-delay="200">
                        <div className="product-item bg-white ">
                            <img className="img-fluid mb-4" style={{ width: '206px', height: '206px' }} src={prod5} alt="Organic Vegetable" />
                            <h6 className="mb-3"> Strawberries</h6>
                            <Link to='/strawberries' className='btn btd-primary bg-primary text-light '>details</Link>

                        </div>
                    </div>


                    <div className="col-md-3 mb-4"data-aos="fade-up" data-aos-delay="200">
                        <div className="product-item bg-white ">
                            <img className="img-fluid mb-4" style={{ width: '206px', height: '206px' }} src={prod6} alt="Organic Vegetable" />
                            <h6 className="mb-3"> Pomegranate </h6>
                            <Link to='/pomegranate' className='btn btd-primary bg-primary text-light '>details</Link>

                        </div>
                    </div>


                    <div className="col-md-3 mb-4"data-aos="fade-up" data-aos-delay="200">
                        <div className="product-item bg-white ">
                            <img className="img-fluid mb-4" style={{ width: '206px', height: '206px' }} src={prod7} alt="Organic Vegetable" />
                            <h6 className="mb-3"> Carrots </h6>
                            <Link to='/carrot' className='btn btd-primary bg-primary text-light '>details</Link>

                        </div>
                    </div>


                    <div className="col-md-3 mb-4"data-aos="fade-up" data-aos-delay="200">
                        <div className="product-item bg-white ">
                            <img className="img-fluid mb-4" style={{ width: '206px', height: '206px' }} src={prod8} alt="Organic Vegetable" />
                            <h6 className="mb-3"> Fresh onion
                            </h6>
                            <Link to='/onion' className='btn btd-primary bg-primary text-light '>details</Link>

                        </div>
                    </div>


                    <div className="col-md-3 mb-4"data-aos="fade-up" data-aos-delay="200">
                        <div className="product-item bg-white ">
                            <img className="img-fluid mb-4" style={{ width: '206px', height: '206px' }} src={prod9} alt="Organic Vegetable" />
                            <h6 className="mb-3">Chili Pepper
                            </h6>
                            <Link to='/chili' className='btn btd-primary bg-primary text-light '>details</Link>

                        </div>
                    </div>

                    <div className="col-md-3 mb-4"data-aos="fade-up" data-aos-delay="200">
                        <div className="product-item bg-white ">
                            <img className="img-fluid mb-4" style={{ width: '206px', height: '206px' }} src={prod14} alt="Organic Vegetable" />
                            <h6 className="mb-3">capsicum (pepper)
                            </h6>
                            <Link to='/capsicum' className='btn btd-primary bg-primary text-light '>details</Link>

                        </div>
                    </div>


                    <div className="col-md-3 mb-4"data-aos="fade-up" data-aos-delay="200">
                        <div className="product-item bg-white ">
                            <img className="img-fluid mb-4" style={{ width: '206px', height: '206px' }} src={prod10} alt="Organic Vegetable" />
                            <h6 className="mb-3"> Fresh Garlic
                            </h6>
                            <Link to='/garlic' className='btn btd-primary bg-primary text-light '>details</Link>

                        </div>
                    </div>


                    <div className="col-md-3 mb-4"data-aos="fade-up" data-aos-delay="200">
                        <div className="product-item bg-white ">
                            <img className="img-fluid mb-4" style={{ width: '206px', height: '206px' }} src={prod11} alt="Organic Vegetable" />
                            <h6 className="mb-3"> Fresh Potato
                            </h6>
                            <Link to='/potato' className='btn btd-primary bg-primary text-light '>details</Link>

                        </div>
                    </div>


                    <div className="col-md-3 mb-4"data-aos="fade-up" data-aos-delay="200">
                        <div className="product-item bg-white ">
                            <img className="img-fluid mb-4" style={{ width: '206px', height: '206px' }} src={prod12} alt="Organic Vegetable" />
                            <h6 className="mb-3">Fresh sweet potato
                            </h6>
                            <Link to='/sweet-potato' className='btn btd-primary bg-primary text-light '>details</Link>

                        </div>
                    </div>


                    <div className="col-md-3 mb-4"data-aos="fade-up" data-aos-delay="200">
                        <div className="product-item bg-white ">
                            <img className="img-fluid mb-4" style={{ width: '206px', height: '206px' }} src={prod15} alt="Organic Vegetable" />
                            <h6 className="mb-3">  Capucha Lettuce </h6>
                            <Link to='/capucha' className='btn btd-primary bg-primary text-light '>details</Link>

                        </div>
                    </div>

                    <div className="col-md-3 mb-4"data-aos="fade-up" data-aos-delay="200">
                        <div className="product-item bg-white ">
                            <img className="img-fluid mb-4" style={{ width: '206px', height: '206px' }} src={prod13} alt="Organic Vegetable" />
                            <h6 className="mb-3"> Barhi </h6>
                            <Link to='/barhi' className='btn btd-primary bg-primary text-light '>details</Link>

                        </div>
                    </div>


                </div>
            </div>
        </div>
        {/*frozen Products End */}
        {/* frozen Products Start */}
        <div className="container-fluid py-5">
            <div className="container">
                <div className="mx-auto text-center mb-5" style={{ maxWidth: '500px' }}>
                    <h6 className="text-primary text-uppercase">Products</h6>
                    <h1 className="display-5">Our frozen Products</h1>
                </div>
                <div className="row text-center">

            
<div className="col-md-3 mb-4" data-aos="fade-up" data-aos-delay="200">
  <div className="product-item  bg-white ">
    <img className="img-fluid mb-4" style={{ width: '206px', height: '206px' }} src={pack4} alt="Organic Vegetable" />
    <h6 className="mb-3">French Fries</h6>
    <Link to='/fries' className='btn btd-primary bg-primary text-light '>details</Link>

  </div>
</div>

<div className="col-md-3 mb-4" data-aos="fade-up" data-aos-delay="200">
  <div className="product-item  bg-white ">
    <img className="img-fluid mb-4" style={{ width: '206px', height: '206px' }} src={pack1} alt="Organic Vegetable" />
    <h6 className="mb-3"> Frozen Okra</h6>
    <Link to='/okra' className='btn btd-primary bg-primary text-light '>details</Link>

  </div>
</div>

<div className="col-md-3 mb-4" data-aos="fade-up" data-aos-delay="200">
  <div className="product-item  bg-white ">
    <img className="img-fluid mb-4" style={{ width: '206px', height: '206px' }} src={pack3} alt="Organic Vegetable" />
    <h6 className="mb-3"> Frozen Broccoli</h6>
    <Link to='/broccoli' className='btn btd-primary bg-primary text-light '>details</Link>

  </div>
</div>

<div className="col-md-3 mb-4" data-aos="fade-up" data-aos-delay="200">
  <div className="product-item  bg-white ">
    <img className="img-fluid mb-4" style={{ width: '206px', height: '206px' }} src={pack7} alt="Organic Vegetable" />
    <h6 className="mb-3"> Egyptian Molokhia (Minced)</h6>
    <Link to='/molokhia' className='btn btd-primary bg-primary text-light '>details</Link>

  </div>
</div>

<div className="col-md-3 mb-4" data-aos="fade-up" data-aos-delay="200">
  <div className="product-item  bg-white ">
    <img className="img-fluid mb-4" style={{ width: '206px', height: '206px' }} src={pack6} alt="Organic Vegetable" />
    <h6 className="mb-3"> Peas with Carrots</h6>
    <Link to='/peas' className='btn btd-primary bg-primary text-light '>details</Link>

  </div>
</div>

<div className="col-md-3 mb-4" data-aos="fade-up" data-aos-delay="200">
  <div className="product-item  bg-white ">
    <img className="img-fluid mb-4" style={{ width: '206px', height: '206px' }} src={pack2} alt="Organic Vegetable" />
    <h6 className="mb-3">Artichoke Bottoms</h6>
    <Link to='/artichoke-bottoms' className='btn btd-primary bg-primary text-light '>details</Link>

  </div>
</div>

<div className="col-md-3 mb-4" data-aos="fade-up" data-aos-delay="200">
  <div className="product-item  bg-white ">
    <img className="img-fluid mb-4" style={{ width: '206px', height: '206px' }} src={pack5} alt="Organic Vegetable" />
    <h6 className="mb-3"> Frozen Cauliflower</h6>
    <Link to='/cauliflower' className='btn btd-primary bg-primary text-light '>details</Link>

  </div>
</div>
<div className="col-md-3 mb-4" data-aos="fade-up" data-aos-delay="200">
  <div className="product-item  bg-white ">
    <img className="img-fluid mb-4" style={{ width: '206px', height: '206px' }} src={pack8} alt="Organic Vegetable" />
    <h6 className="mb-3"> Frozen Strawberries</h6>
    <Link to='/frozen-strawberries' className='btn btd-primary bg-primary text-light '>details</Link>

  </div>
</div>
<div className="col-md-3 mb-4" data-aos="fade-up" data-aos-delay="200">
  <div className="product-item  bg-white ">
    <img className="img-fluid mb-4" style={{ width: '206px', height: '206px' }} src={pack10} alt="Organic Vegetable" />
    <h6 className="mb-3"> Frozen Mango Slices</h6>
    <Link to='/mango' className='btn btd-primary bg-primary text-light '>details</Link>

  </div>
</div>
<div className="col-md-3 mb-4" data-aos="fade-up" data-aos-delay="200">
  <div className="product-item  bg-white ">
    <img className="img-fluid mb-4" style={{ width: '206px', height: '206px' }} src={pack9} alt="Organic Vegetable" />
    <h6 className="mb-3">Frozen Sliced Guava</h6>
    <Link to='/guava' className='btn btd-primary bg-primary text-light '>details</Link>

  </div>
</div>

</div>
            </div>
        </div>

        <div className="container-fluid bannerr  my-5">
            <div className="container py-5">
                <div className="row g-4 align-items-center">
                    <div className="col-lg-6">
                        <div className="py-4">
                            <h1 className="display-3 text-white">Fresh & frozen Products</h1>
                            <p className="fw-normal display-3 text-secondary mb-4">in Our Store</p>

                            <Link to='/contact' className="btn bg-primary border-2 border-white rounded-pill text-light py-3 px-5">BUY</Link>
                        </div>
                    </div>
             
                </div>
            </div>
        </div>
{/* //////////////////////////////////////////////// */}


        <div className="container-fluid py-5">
            <div className="container">
                <div className="mx-auto text-center mb-5" style={{ maxWidth: "500px" }}>
                    <h6 className="text-primary text-uppercase">Contact Us</h6>
                    <h1 className="display-5">Please Feel Free To Contact Us</h1>
                </div>
                <div className="row g-0">
                    <div className="col-lg-7">
                        <div className="bg-primary h-100 p-5">
                            <form>
                                <div className="row g-3">
                                    <div className="col-6">
                                        <input type="text" className="form-control bg-light border-0 px-4" placeholder="Your Name" style={{ height: "55px" }} data-aos="fade-right" data-aos-delay="200" />
                                    </div>
                                    <div className="col-6">
                                        <input type="email" className="form-control bg-light border-0 px-4" placeholder="Your Email" style={{ height: "55px" }} data-aos="fade-right" data-aos-delay="150"/>
                                    </div>
                                    <div className="col-12">
                                        <input type="text" className="form-control bg-light border-0 px-4" placeholder="Subject" style={{ height: "55px" }} data-aos="fade-right" data-aos-delay="100"/>
                                    </div>
                                    <div className="col-12">
                                        <textarea className="form-control bg-light border-0 px-4 py-3" rows="2" placeholder="Message" data-aos="fade-right" data-aos-delay="90"></textarea>
                                    </div>
                                    <div className="col-12">
                                        <button className="btn btn-secondary w-100 py-3" type="submit">Send Message</button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div className="col-lg-5">
                        <div className=" h-100 p-5">
                            <h2 className="text-dark mb-4">Get In Touch</h2>
                            <div className="d-flex mb-4" data-aos="fade-left" data-aos-delay="280">
                                <div className="bg-primary rounded-circle d-flex align-items-center justify-content-center" style={{ width: "60px", height: "60px" }}>
                                    <i className="fas fa-map-marker-alt text-dark"></i>
                                </div>
                                <div className="ps-3" >
                                    <h5 className="text-dark">Our Office</h5>
                                    <span className="text-dark">Ademon Fremon Street, Maadi Smouha Building 2, first floor</span>
                                </div>
                            </div>
                            <div className="d-flex mb-4" data-aos="fade-left" data-aos-delay="300">
                                <div className="bg-primary rounded-circle d-flex align-items-center justify-content-center" style={{ width: "60px", height: "60px" }}>
                                    <i className="fas fa-envelope text-dark"></i>
                                </div>
                                <div className="ps-3" >
                                    <h5 className="text-dark" >Email Us</h5>
                                    <span className="text-dark">Info@elshebany.com</span>
                                </div>
                            </div>
                            <div className="d-flex" data-aos="fade-left" data-aos-delay="350">
                                <div className="bg-primary rounded-circle d-flex align-items-center justify-content-center" style={{ width: "60px", height: "60px" }}>
                                    <i className="fas fa-phone-alt  fs-4 text-dark"></i>
                                </div>
                                <div className="ps-3">
                                    <h5 className="text-dark">Call Us</h5>
                                    <span className="text-dark">+201553394447</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>
}
